import { useParams, useNavigate } from 'react-router-dom';
import { Card, Button } from 'react-bootstrap';
import { PageCardWrapper } from '../../../../sitel/demon/ui/atoms';
import { useBaseUrlSwitchMAT } from '../../../../services/urlServices';
import {
  MEDSTAR_ASSOCIATION_TYPE__VENDOR,
  MEDSTAR_ASSOCIATION_TYPE__STUDENT,
  //silenced for now MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR,
  MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER,
  MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER,
} from '../../../../sitel/commons/utilities/medstarAssociationType';

export default function NoneEmployeeHeader() {
  const baseUrlMAT = useBaseUrlSwitchMAT();
  const navigate = useNavigate();
  const { medstarAssociationType } = useParams();

  const isActive = (testMedstarAssociationType) => {
    if (testMedstarAssociationType === medstarAssociationType) {
      return 'primary';
    } else {
      return 'outline-primary';
    }
  };

  const switchMAT = (newMedstarAssociationType) => {
    navigate(baseUrlMAT(newMedstarAssociationType) + '/step5/profile');
  };

  return (
    <PageCardWrapper title='This information is required for reporting and to help identify any previous MedStar Health accounts.'>
      <Card.Body>
        <Card.Title>Select an option below</Card.Title>

        <Card.Text>Help us understand who your employer/school is to better guide you in this process.</Card.Text>
        <Card.Text>
          <b>I am a...</b>
        </Card.Text>
        <div className='text-center'>
          <Button variant={isActive(MEDSTAR_ASSOCIATION_TYPE__STUDENT)} onClick={() => switchMAT(MEDSTAR_ASSOCIATION_TYPE__STUDENT)}>
            Student
          </Button>{' '}
          <Button variant={isActive(MEDSTAR_ASSOCIATION_TYPE__VENDOR)} onClick={() => switchMAT(MEDSTAR_ASSOCIATION_TYPE__VENDOR)}>
            Contractor/Vendor
          </Button>{' '}
          <Button variant={isActive(MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER)} onClick={() => switchMAT(MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER)}>
            Board Member
          </Button>{' '}
          <Button variant={isActive(MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER)} onClick={() => switchMAT(MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER)}>
            Volunteer
          </Button>
        </div>
      </Card.Body>
    </PageCardWrapper>
  );
}
